import React from 'react';
import { SHOPPING_CART_FOOTER_LAYOUTS } from '@/utils/constants';
import ShoppingCartFooterConfigMobile from './ShoppingCartFooterConfigMobile';
import ShoppingCartFooterConfigMobileFlyOut from './ShoppingCartFooterConfigMobileFlyOut';
import ShoppingCartFooterModalFichaDesktop from './ShoppingCartFooterModalFichaDesktop';
import ShoppingCartFooterModalFichaMobile from './ShoppingCartFooterModalFichaMobile';
import { useSelector } from "react-redux";
import { getModuleNamesTagginInfo } from "@/utils/index";
import { API_STATUS } from "@/utils/constants";


const ShoppingCartFooter = ({ layoutType, ...props }) => {
    const layoutsMap = {
      [SHOPPING_CART_FOOTER_LAYOUTS.CONFIG_MOBILE]: ShoppingCartFooterConfigMobile,
      [SHOPPING_CART_FOOTER_LAYOUTS.CONFIG_MOBILE_FLYOUT]: ShoppingCartFooterConfigMobileFlyOut,
      [SHOPPING_CART_FOOTER_LAYOUTS.MODAL_FICHA_MOBILE]: ShoppingCartFooterModalFichaMobile,
      [SHOPPING_CART_FOOTER_LAYOUTS.MODAL_FICHA_DESKTOP]: ShoppingCartFooterModalFichaDesktop,
    };
     const {
        layout,
        modulos,
        clientModules,
        userType,
        statusModulos,
        statusSelection,
        permanence,
      } = useSelector((state) => ({
        layout: state.UI.layout,
        modulos: state.cart.modulos,
        clientModules: state.client.modulos,
        userType: state.main.context?.userType,
        statusModulos: state.modulos.statusModulos,
        statusSelection: state.modulos.statusSelection,
        permanence: state.UI.permanence,
      }));      
        const isLoading =
          statusModulos === API_STATUS.LOADING ||
          statusSelection === API_STATUS.LOADING;
          const stateProps = {
            layout,
        modulos,
        clientModules,
        userType,
        statusModulos,
        statusSelection,
        permanence,
        isLoading
          };
  const LayoutComponent = layoutsMap[layoutType];
  if(!props?.taggingInfo) {
      const taggingInfo = {
        componentName: "ShoppingCartFooter",
        componentProduct: getModuleNamesTagginInfo(
          modulos,
          layout,
          clientModules,
          userType
        ),
        componentContent: 'Contratar',
        componentVariation: "",
      };
      props.taggingInfo = taggingInfo;
    }
return (
    <>
      {LayoutComponent && (
        <LayoutComponent {...props} stateProps={stateProps} />
      )}
      <style jsx global>{`
        .shoppingCartBoxShadow {
          box-shadow: 0px -2px 8px #00000029;
        }
      `}</style>
    </>
  )
};

export default ShoppingCartFooter;
